function renderColumnDefLayoutTemplate({ colAccessorKey }: { colAccessorKey: string }): string {
  return `cell: ({ row }) => {
      const email = row.getValue('${colAccessorKey}') as string
      return <div className="text-sm font-medium">{email || '-'}</div>
    }`
}

function renderColumnDefDateTemplate({ colAccessorKey }: { colAccessorKey: string }): string {
  return `cell: ({ row }) => {
      const date = row.getValue('${colAccessorKey}') as string
      return date ? new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '-'
    }`
}

function renderColumnDefValueTemplate({ colAccessorKey }: { colAccessorKey: string }): string {
  return `cell: ({ row }) => {
      const value = row.getValue('${colAccessorKey}') as string
      return <Badge variant="outline">{value || 'N/A'}</Badge>
    }`
}

function renderColumnDefLayoutDetailsTemplate({
  colAccessorKey
}: {
  colAccessorKey: string
}): string {
  return `cell: ({ row }) => {
      const value = row.getValue('${colAccessorKey}') as number
      return <div className="text-right">{value !== null && value !== undefined ? value : '-'}</div>
    }`
}

function renderColumnDefValueDetailsTemplate({
  colAccessorKey
}: {
  colAccessorKey: string
}): string {
  return `cell: ({ row }) => {
      const value = row.getValue('${colAccessorKey}') as string
      return <div>{value || '-'}</div>
    }`
}

function renderColumnDefContentTemplate({
  colAccessorKey,
  columnSize,
  sortableHeader,
  cellDef
}: {
  colAccessorKey: string
  columnSize: string
  sortableHeader: string
  cellDef: string
}): string {
  return `  {
    accessorKey: '${colAccessorKey}',
    ${columnSize}${sortableHeader},
    ${cellDef}
  }`
}

export function renderAdminColumnDefRenderer(
  request:
    | {
        kind: 'renderColumnDefLayoutTemplate'
        props: {
          colAccessorKey: string
        }
      }
    | {
        kind: 'renderColumnDefDateTemplate'
        props: {
          colAccessorKey: string
        }
      }
    | {
        kind: 'renderColumnDefValueTemplate'
        props: {
          colAccessorKey: string
        }
      }
    | {
        kind: 'renderColumnDefLayoutDetailsTemplate'
        props: {
          colAccessorKey: string
        }
      }
    | {
        kind: 'renderColumnDefValueDetailsTemplate'
        props: {
          colAccessorKey: string
        }
      }
    | {
        kind: 'renderColumnDefContentTemplate'
        props: {
          colAccessorKey: string
          columnSize: string
          sortableHeader: string
          cellDef: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderColumnDefLayoutTemplate':
      return renderColumnDefLayoutTemplate(request.props)
    case 'renderColumnDefDateTemplate':
      return renderColumnDefDateTemplate(request.props)
    case 'renderColumnDefValueTemplate':
      return renderColumnDefValueTemplate(request.props)
    case 'renderColumnDefLayoutDetailsTemplate':
      return renderColumnDefLayoutDetailsTemplate(request.props)
    case 'renderColumnDefValueDetailsTemplate':
      return renderColumnDefValueDetailsTemplate(request.props)
    case 'renderColumnDefContentTemplate':
      return renderColumnDefContentTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
